import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SourceComponent } from './source.component';
import { AddSourceComponent } from './add-source/add-source.component';
import { EditSourceComponent } from './edit-source/edit-source.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [SourceComponent, AddSourceComponent, EditSourceComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [SourceComponent],
})
export class SourceModule {}
